// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import Wishlists from 'Containers/Wishlists/Wishlists';
import ProductsProvider from 'Contexts/ProductsContext';
import ProductQuickViewModal from 'Containers/Products/ProductQuickViewModal';
import CreateWishlistModal from 'Containers/Wishlists/CreateWishlistModal';

const StyledAccountLayout = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const WishlistsPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.wishlists') } | { t('common.pages.account') }</title>
      </Helmet>
      <ProductsProvider>
        <CreateWishlistModal />
        <ProductQuickViewModal />
        <StyledAccountLayout theme={ theme } className="grid-container">
          <AccountSideMenu />
          <Wishlists />
        </StyledAccountLayout>
      </ProductsProvider>
    </>
  );
});

export default WishlistsPage;
